import adminApi from "../../connection/adminApi";

// Last known vector store state per store id, so the dots paint instantly on
// the next visit while a fresh answer loads in the background.
const STORAGE_KEY = "storakAdminVectorStatus";
const MAX_CONCURRENT = 3;

const readAll = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {};
  } catch {
    return {};
  }
};

export const readCachedVectorState = (storeId) => readAll()[storeId] || null;

const writeCached = (storeId, status) => {
  if (!status || status.error) {
    return;
  }

  try {
    const all = readAll();
    all[storeId] = { state: status.state, checkedAt: status.checkedAt };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    // storage full or blocked: the dot just loads without a head start
  }
};

// The list asks for every row at once; a small queue keeps that from firing
// twenty Weaviate scans in parallel.
let active = 0;
const waiting = [];

const runNext = () => {
  if (active >= MAX_CONCURRENT || !waiting.length) {
    return;
  }

  active += 1;
  const { task, resolve, reject } = waiting.shift();

  task()
    .then(resolve, reject)
    .finally(() => {
      active -= 1;
      runNext();
    });
};

const enqueue = (task) =>
  new Promise((resolve, reject) => {
    waiting.push({ task, resolve, reject });
    runNext();
  });

const request = async (storeId, fresh) => {
  const { data } = await adminApi.get(
    `api/admin/stores/${storeId}/vector-status`,
    { params: fresh ? { fresh: 1 } : {} }
  );
  writeCached(storeId, data);
  return data;
};

/**
 * `fresh` (Store data tab) skips the server's 10-minute cache and the queue,
 * so an open tab never waits behind list rows; the list uses cached answers.
 */
export const fetchVectorStatus = (storeId, { fresh = false } = {}) =>
  fresh ? request(storeId, true) : enqueue(() => request(storeId, false));
